import React from "react";
import PhotoGallery from "./PhotoGallery";

const Photo = ({ environment }) => {
  return (
    <div className="col-lg-6 col-xl-3 col-md-6 col-12">
      <div className="e-school-environment-single">
        <div className="e-school-env-img">
          <PhotoGallery galleryID={environment?.id} images={environment} />
        </div>
        <div className="e-school-env-content">
          <h4 className="e-school-env-cont-tag">IT Solution</h4>
          <h3 className="e-school-env-cont-title">Big Data Science</h3>
        </div>
      </div>
    </div>
  );
};

export default Photo;
